import React, { FC, useContext } from 'react';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';

import CustomAccordion from '../../../sharedModules/layout/CustomAccordion';
import ObjectBreakdown from '../../../sharedModules/layout/ObjectBreakdown';

import Delete from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

import { DeleteConfirmationModalContext } from '../../../sharedModules/contexts/DeleteConfirmationModalContext';

interface AssetInfoCardProps {
  asset: any;
  certificateSubmissionId: string;
}

const AssetInfoCard: FC<AssetInfoCardProps> = (props) => {
  let { asset, certificateSubmissionId } = props;

  let { setAdditionalParams, setModelLabel, setDeleteConfirmationModalOpen, setRecordToDelete, setDeleteURL } =
    useContext(DeleteConfirmationModalContext);

  const handleRemoveClicked = () => {
    setAdditionalParams({ certificate_submission_id: certificateSubmissionId });
    setDeleteURL('energy_solutions/certificate_submissions_assets');
    setModelLabel('included Asset');
    setDeleteConfirmationModalOpen(true);
    setRecordToDelete(asset);
  };

  const hasSpecifxData = () => {
    if (!asset?.specifx_info) return false;
    if (typeof asset.specifx_info === 'object') {
      return Object.keys(asset.specifx_info).length > 0;
    }
    return asset.specifx_info.toString().trim() !== '';
  };

  return (
    <Card>
      <Grid container>
        <Grid item xs={12} sx={{ p: '5px', pl: '15px' }}>
          <Grid container style={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={6} md={3}>
              {asset.manufacturer_name}
            </Grid>
            <Grid item xs={6} md={4}>
              {asset.model_number}
            </Grid>
            <Grid item xs={12} md={5}>
              <Box display="flex" gap={1} justifyContent="flex-end" alignItems="center">
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<Delete />}
                  onClick={handleRemoveClicked}
                  color="error"
                  sx={{ minWidth: 'auto' }}
                >
                  Remove
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {hasSpecifxData() && (
          <Grid item xs={12}>
            <CustomAccordion
              summary="Specifx Info"
              detailComponent={<ObjectBreakdown data={asset.specifx_info} />}
              backgroundColor="#D6A3AC"
            />
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default AssetInfoCard;
